import React, { useState } from "react";
import {
    Button,
    ListGroupItem,
    Glyphicon,
    ButtonGroup,
    Modal,
} from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import MoveIcon from "../../../Widgets/components/Icons/MoveIcon";
import DeleteConfirmOverlay from "../../../../UI/DeleteConfirmOverlay";
import { createStream, deleteStream, orderStream } from "../../../../../../api/cp/stream";
import cloneDeep from "lodash.clonedeep";
import StreamModal from "./StreamModal";

export default ({ event, setEvent }) => {
    const [saving, setSaving] = useState(false);
    const [editingStreamID, setEditingStreamID] = useState(null);

    const updateEvent = (stream) => {
        setEvent(event => ({ ...event, stream }))
    }

    const handleDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }

        let streams = cloneDeep(event.stream);
        const streamsCopy = cloneDeep(event.stream);
        const [removed] = streams.splice(result.source.index, 1);
        streams.splice(result.destination.index, 0, removed);
        streams = streams.map((stream, idx) => ({ ...stream, order: idx + 1 }));

        updateEvent(streams);
        setSaving(true);

        orderStream(event.eventKey, { order: streams.map(({ id }) => id) })
            .catch((e) => {
                console.error(e);
                updateEvent(streamsCopy);
            })
            .finally(() => setSaving(false))
    }

    const handleAddStream = () => {
        setSaving(true);
        createStream(event.eventKey, {
            descriptionRu: 'Новый зал',
            timeStart: event.timeStart,
            timeStop: event.timeStop,
        })
            .then(stream => {
                if (!stream.liveProfileId) {
                    alert('ВНИМАНИЕ!\nНе удалось назначить Live CDN профиль!\nВещание не возможно. Для выбора профиля вещания, обратитесь в тех поддержку.');
                }
                updateEvent([...event.stream, stream]);
                setEditingStreamID(stream.id);
            })
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    const handleDeleteStream = (stream) => {
        setSaving(true);
        deleteStream(stream.id)
            .then(() => updateEvent(event.stream.filter(({ id }) => id !== stream.id)))
            .catch(e => console.error(e))
            .finally(() => setSaving(false))
    }

    return <div style={{ position: 'realtive' }}>
        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Button onClick={handleAddStream} disabled={saving}>Добавить зал</Button>
        </div>
        <div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {event.stream.sort((a, b) => a.order - b.order).map((stream, index) => (
                                <Draggable
                                    key={stream.id}
                                    draggableId={`${stream.id || index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                                ...provided.draggableProps.style,
                                            }}
                                        >
                                            <ListGroupItem
                                                style={{
                                                    padding: '4px 4px 4px 12px',
                                                    display: 'flex',
                                                    height: '44px',
                                                    marginBottom: '0.5rem',
                                                    alignItems: 'center',
                                                    gap: '1rem',
                                                    fontWeight: 600,
                                                    backgroundColor: stream.timeStart < event.timeStart || stream.timeStop > event.timeStop ? 'rgb(255, 200, 200)' : 'white'
                                                }}
                                            >
                                                <div style={{ minWidth: 20 }}>
                                                    <MoveIcon />
                                                </div>
                                                <span style={{ flex: 1, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{stream.description_ru}</span>
                                                <ButtonGroup>
                                                    <Button onClick={() => setEditingStreamID(stream.id)} disabled={saving}>
                                                        <Glyphicon glyph="edit" />
                                                    </Button>
                                                    <DeleteConfirmOverlay title="Удалить этот зал?" buttonText="Удалить" onConfirm={() => handleDeleteStream(stream)}>
                                                        <Button bsStyle="danger" disabled={saving}><Glyphicon glyph="trash" /></Button>
                                                    </DeleteConfirmOverlay>
                                                </ButtonGroup>
                                            </ListGroupItem>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
        <Modal
            show={editingStreamID !== null}
            onHide={() => setEditingStreamID(null)}
        >
            <Modal.Header closeButton>
                <Modal.Title>Настройки зала</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <StreamModal
                    event={event}
                    streamID={editingStreamID}
                    updateStreams={(stream) => updateEvent(event.stream.map(_stream => _stream.id === stream.id ? stream : _stream))}
                    onClose={() => setEditingStreamID(null)}
                />
            </Modal.Body>
        </Modal>
    </div>
}